import HttpClient from "@/common/boot/HttpClient"

const listarEmails = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get('/pco-emails-queue', { params: payload })
    
    const paginatedData = response.data.data
    
    commit('LISTAR_DADOS', paginatedData)
    return response
  } catch (error) {
    console.error('Erro ao listar emails:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

export {
  listarEmails
}
